<template>
  <textarea
    v-if="!dense"
    :class="[
      'w-full bg-white block rounded-md border-0  text-gray-900 focus:ring-2 focus:ring-primary text-xs sm:leading-6',
      dense ? '' : 'py-1.5 pl-3 pr-10 ring-1 ring-inset ring-gray-300 ',
      valueClasses,
    ]"
    ref="textarea"
    :style="{ minHeight: minHeight, overflow: 'hidden' }"
    @input="autoExpand"
    v-model="inputValue"
  ></textarea>

  <textarea
    v-else
    :class="[
      'w-full block  border-0 py-1.5 text-gray-900 shadow-sm  placeholder:text-gray-400 focus:ring-1  ring-primary focus:ring-primary focus:bg-primary/5 hover:ring-1 text-sm sm:leading-6',
      valueClasses,
    ]"
    :style="{ minHeight: minHeight, overflow: 'hidden' }"
    ref="textarea"
    @input="autoExpand"
    v-model="inputValue"
  />
</template>
<script setup lang="ts">
import { defineProps, onMounted, ref, watch } from "vue";

const props = defineProps({
  modelValue: {
    // type: any,
    default: "",
  },
  minHeight: {
    type: String,
    default: "80px", // Set a default minimum height
  },
  valueClasses: {
    type: String,
    default: "",
  },
  dense: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);
const textarea = ref(null);
const inputValue = ref(props.modelValue);

// Emit input event to support v-model on the component
watch(inputValue, (newValue) => {
  emit("update:modelValue", newValue);
});

// Automatically adjust the height to fit the content
const autoExpand = () => {
  if (textarea.value) {
    textarea.value.style.height = "inherit"; // Reset height to recalculate
    const computed = window.getComputedStyle(textarea.value);
    const height =
      textarea.value.scrollHeight +
      parseInt(computed.borderTopWidth) +
      parseInt(computed.borderBottomWidth);
    textarea.value.style.height = `${height}px`;
  }
};

onMounted(() => {
  // console.log("mounted");
  autoExpand();
});

// Adjust the height when the component is mounted and when the value changes
watch(
  () => props.modelValue,
  (newValue) => {
    // console.log("value changed");
    inputValue.value = newValue;
    textarea.value && autoExpand();
  },
  { immediate: true }
);
</script>
